
export const DEFAULT_BLUE = "#1B91DD";
//export const DEFAULT_BLUE = "#3CACFF";
//export const DEFAULT_BLUE = "#4BAEF3";
export const BUTTON_COLOR = "#1B91DD";
export const ADMIN_BLUE = "#1D2D4B";
//export const ADMIN_BLUE = "#333";
export const ADMIN_BACKGROUND = "#F6F7F8";
export const ADMIN_DARK_GREY = "#DDE2E6";
export const DARK_BLUE = "#1D2D4B";
export const TABLE_HEADER_COLOR = "black";
export const TABLE_TYPE_STANDARD = "TABLE_TYPE_STANDARD";
export const TABLE_TYPE_METRIC = "TABLE_TYPE_METRIC";
export const TABLE_TYPE_SCORECARD = "TABLE_TYPE_SCORECARD";
export const FORWARD = "FORWARD";
export const BACKWARD = "BACKWARD";
export const TEXT_COLOR_LIGHT = "#fff";
export const TEXT_COLOR_DARK = "#444";
export const FACE_HAPPY = "FACE_HAPPY";
export const FACE_SAD = "FACE_SAD";
export const COLOR_GREEN = "rgb(0, 153, 0)";
export const COLOR_RED = "rgb(221, 0, 0)";
export const COLOR_BLUE = "#1685C0";
export const POSITIVE = "POSITIVE";
export const NEGATIVE = "NEGATIVE";
export const DATA_TYPE_NUMBER= "DATA_TYPE_NUMBER";
export const DATA_TYPE_DATE= "DATA_TYPE_DATE";
export const DIRECTION_UP = "UP";
export const DIRECTION_DOWN = "DOWN";
export const DIRECTION_EQUALS = "EQUALS";
export const GREEN = "GREEN";
export const RED = "RED";
export const AMBER = "AMBER";
export const TRUE = "TRUE";
export const FALSE = "FALSE";
export const HIGHLIGHT_COLOR = "#ffcc00";
export const NEW = "NEW";
export const GOOGLE_MAPS_KEY = "AIzaSyBeSB5P9joQfeQu-7URnI75zjbMZZqA1eQ";
export const ESRI_MAPS_KEY = "AAPK6303ec5309fc437d9d52ec9f27b36aadgbK_R4jteMWKvtunevvGDCwYIbrP3u_X-MN8lJ2j0WR2sK3Dnk5391OQgWGTRtY4";
export const BACKGROUND_BLUE = "#004B81";
//export const BACKGROUND_BLUE = "#0D1F3A";
export const BACKGROUND_DARK_GREY = "#333";
export const BACKGROUND_LIGHT_GREY = "#666";
export const BACKGROUND_WHITE = "#fff";
export const BACKGROUND_BLACK = "#0D1118";
export const NO_STRINGIFY = "NO_STRINGIFY";
export const STRINGIFY = "STRINGIFY";
export const GRADIENT_BACKGROUND = "linear-gradient(#1C99CC, #117CA5)";
export const GRADIENT_GREEN = "linear-gradient(#00ff00, #009900)";
export const GRADIENT_RED = "linear-gradient(#ff0000, #990000)";
export const GRADIENT_YELLOW = "linear-gradient(to bottom right, #FFdd22, #bb8800)";
export const BLACK_BACKGROUND = "linear-gradient(#444, #000)";
export const TABLE_BORDER_COLOR = "#999";
export const RAG_COLOR_RED = "#ff2a00";
export const RAG_COLOR_AMBER = "#ffbd00";
export const RAG_COLOR_GREEN = "#009900";
//export const HEADER_COLOR = "#24285B";
//export const HEADER_COLOR = "#001443";
export const HEADER_COLOR = "#001443";
export const TABLE_TEXT_COLOR = "#000";
export const COLOR_GREY_LIGHT = "#e8eaed";
export const COLOR_GRAY_BANNER_BACKGROUND = "#233142";
export const COLOR_SLATEGRAY = "slategray";

export const DATA_TYPE_ATTRIBUTE = {id:1, name:"ATTRIBUTE"};
export const DATA_TYPE_CLASSIFICATION = {id:2, name:"CLASSIFICATION"};
export const DATA_TYPE_METRIC = {id:3, name:"METRIC"};
export const DATA_TYPE_SCORECARD = {id:4, name:"SCORECARD"};

export const LINK_TYPE_GEOGRAPHY = "1";
export const LINK_TYPE_FACILITY = "2";
export const LINK_TYPE_FACILITY_SPACE = "3";
export const LINK_TYPE_FACILITY_SYSTEM = "4";
export const LINK_TYPE_ASSET = "5";

export const CHART_TYPE_PIE = "CHART_TYPE_PIE";
export const CHART_TYPE_BAR = "CHART_TYPE_BAR";
export const CHART_TYPE_COLUMN = "CHART_TYPE_COLUMN";

export const MAP_ENTITY_TYPE_GLOBAL = "0";
export const MAP_ENTITY_TYPE_SITE="1";
export const MAP_ENTITY_TYPE_BUILDING="2";

export const REPORT_BOX_WIDTH_33 = "REPORT_BOX_WIDTH_33";
export const REPORT_BOX_WIDTH_50 = "REPORT_BOX_WIDTH_50";
export const REPORT_BOX_WIDTH_100 = "REPORT_BOX_WIDTH_100";

export const AREA_UNIT_SQM = "SQM";
export const AREA_UNIT_SQFT = "SQFT";

export const SCREEN_WIDTH_PHONE = 479;
export const SCREEN_WIDTH_TABLET = 1200;
export const SCREEN_WIDTH_STANDARD = 1400;
export const SCREEN_WIDTH_LARGE = 1700;

export const SCAN_TYPE_MATTERPORT = "SCAN_TYPE_MATTERPORT";
export const SCAN_TYPE_ATIS = "SCAN_TYPE_ATIS";
export const SCAN_TYPE_CINTOO = "SCA_TYPE_CINTOO";
export const SCAN_TYPE_TRUEVIEW = "SCAN_TYPE_TRUEVIEW";

export const SYSTEM_ROLE_SUPERADMIN = "SUPERADMIN";
export const SYSTEM_ROLE_ADMIN = "ADMIN";
export const SYSTEM_ROLE_CONTENT_CREATOR = "CONTENTCREATOR";


export const COLOR_GRAY_DASHBOARD_BACKGROUND = "#4F5A68";

export const SYSTEM_ROLES  = [
	{id:"SUPERADMIN", name:"Super Administrator"},
	{id:"ADMIN", name:"Administrator"},
	{id:"CONTENTCREATOR", name:"Content Creator"},
	{id:"READER", name:"Reader"}
];

export const YES_NO_OPTIONS = [
		{value:"Y", text:"Yes"},
		{value:"N", text:"No"}
];

export const APPLIES_TO_OPTIONS = [
		{value:"1", text:"Geography"},
		{value:"2", text:"Facility"},
		{value:"3", text:"Facility Space/Floor"}	
];

export const IMAGE_SECOND_LOGO = "second_logo.png";
export const IMAGE_CLIENT_LOGO = "client_logo.png";

export const THIS_ORANGE="yellow";
export const PURPLE = "#74118A";
export const GREY_BACKGROUND = "#EEF1F6";

export const TREE_SELECTOR_TREE_TYPE_SPACE_TYPE = "TREE_SELECTOR_TREE_TYPE_SPACE_TYPE";
export const TREE_SELECTOR_TREE_TYPE_CLASSIFICATION_ITEM = "TREE_SELECTOR_TREE_TYPE_CLASSIFICATION_ITEM";
export const TREE_SELECTOR_TREE_DASHBOARD_SPACE_TYPE = "TREE_SELECTOR_TREE_DASHBOARD_SPACE_TYPE";
export const TREE_SELECTOR_TREE_DASHBOARD_CLASSIFICATION_ITEM = "TREE_SELECTOR_TREE_DASHBOARD_CLASSIFICATION_ITEM";

export const UTILISATION_SHOW_DESK = "UTILISATION_SHOW_DESK";
export const UTILISATION_SHOW_MEETING = "UTILISATION_SHOW_MEETING";
export const UTILISATION_SHOW_TECHNICAL = "UTILISATION_SHOW_TECHNICAL";
export const UTILISATION_SHOW_REMAINDER = "UTILISATION_SHOW_REMAINDER";

export const UTILISATION_DASHBOARD_TYPE_SOL = "UTILISATION_DASHBOARD_TYPE_SOL";
export const UTILISATION_DASHBOARD_TYPE_ACTIVITY = "UTILISATION_DASHBOARD_TYPE_ACTIVITY";

export const COLOR_FOCUS = "#1CD7D0";
export const COLOR_EDIT = "#0CAB50";
export const COLOR_MEETING = "#EA2863";
export const COLOR_ALTERNATIVE = "#EC6CF4";
export const COLOR_SOCIAL = "#3434CF";

//export const SYSTEM_BLUE_BACKGROUND = "#0D6FAD";
export const SYSTEM_BLUE_BACKGROUND = "#08537E";
export const SYSTEM_BLUE_BACKGROUND_LIGHT = "#116395";
export const SYSTEM_BLUE_BORDER = "#6EB5DA";

export const UNSET = "-100";

export const IMPORT_TYPES = [
  { value: "UTILISATION_GRID", label: "Utilisation grid upload" },
  { value: "TIMETABLE_EXAMS", label: "Timetable exams upload" }
];

export const FORGE_VIEWER_TYPE_PANEL = "OMNISCAN_PANEL";
export const FORGE_VIEWER_TYPE_NO_PANEL = "OMNISCAN_NO_PANEL";


